class ReadMore extends HTMLElement {
    constructor() {
        super();
        this.toggleButton = this.querySelector('#toggle-button');
        if (!this.toggleButton) return;
        this.toggleButton.addEventListener('click', this.toggleReadMore.bind(this));
    }

    toggleReadMore() {
        const fullText = this.querySelector('.full-text');
        const isOpen = this.toggleButton.textContent.trim() === 'Read More';

        if (isOpen) {
            this.toggleButton.textContent = 'Read Less';
            this.classList.add('open');
            this.toggleButton.setAttribute('aria-expanded', 'true');
        } else {
            this.toggleButton.textContent = 'Read More';
            this.classList.remove('open');
            this.toggleButton.setAttribute('aria-expanded', 'false');
        }
    }
}
customElements.define('read-more', ReadMore);

/* <read-more>
    <p>This is a short excerpt of text that will be shown initially. It provides a brief overview of the content. <span class="full-text">Here is the additional content that will be revealed when the user clicks "Read More". This part contains more details and information that may be useful for the reader.</span></p>
    <div class="read-more">
        <span class="read-more-button" id="toggle-button">Read More</span>
    </div>
</read-more> */
